import { lazy } from 'react';

const FinancePage = lazy(() => import('../pages/Finance.page'));

export const FinanceRoutes = [
    {
        path: 'finance',
        element: <FinancePage />,
    },
];
